import Axios, { AxiosRequestConfig } from "axios";
import { useUserStore } from "@/store/userStore";

export default class ApiConfig {
  userStore = useUserStore();

  constructor() {
    Axios.defaults.withCredentials = false;
  }
  getBaseUrl(defaultUrl: string): string {
    const webapiHost =
      process.env.VUE_APP_BACKEND_URI !== undefined
        ? process.env.VUE_APP_BACKEND_URI
        : "";

    return webapiHost;
  }

  transformOptions(options: AxiosRequestConfig) {
    options.headers = {
      ...options.headers,

      Authorization: `Bearer ${this.userStore.accessToken}`,
    };

    // tslint:disable-next-line:no-any
    //(options as any).credentials = "include";
    return Promise.resolve(options);
  }
}
